import React from 'react'
import { Homecon } from '../Home/Home.styles'
import { ItemCon,Imagecon } from './SubCatItemDetails.styles'

const SubCatItemDetails = () => {
  return (
    <Homecon>
      <ItemCon>
        <Imagecon>

        </Imagecon>
      </ItemCon>
    </Homecon>
  )
}

export default SubCatItemDetails
